import { activeBoardHandler } from "./activeBoardHandler";
import { storesingleboard } from "./add-single-board";
import { addNoteBoard, getNoteBoard } from "./AddNote";
import { boardDeactivate } from "./board-deactivate";
import { bulkUpdate } from "./bulkUpdate";
import { checkLinkForSideMenu } from "./checkLinkForSideMenu";
import { columnOrdering } from "./column-ordering";
import { columnResize } from "./columns-resize";
import {
  createattribute,
  fetchAllcolumns,
  fetchAllRows,
} from "./create-attribute";
import { deleteboard } from "./delete-board";
import { fetAllBoards, keepAllNameAndKey } from "./fetch-all-boards";
import {
  fetchattributelistingforboard,
  getTattleDetails,
} from "./fetch-board-attribute-listing";
import { getBoardStatusDetails } from "./get-board-status-details";
import { hideColumn, showColumns } from "./hideColumn";
import { loginDetails } from "./loginDetails";
import { renameAttribute } from "./rename-attribute";
import { renamesingleboard } from "./rename-single-board";
import { showattribute } from "./show-attribute";
import { status } from "./statusworkflow";
import {
  assignToUpdate,
  getBoardHistory,
  updateAssignTo,
  updateSingleRow,
} from "./update-single-row";
import { stopPopup } from "./StopPopup";
import { BoardMessageDeactivate } from "./BoardMessageDeactivate";
import { statusChangeMessage } from "./statusChangeMessage";
import { setNewStatus } from "./setNewStatus";
import { removeAttachmnt } from "./remove-attachment";
import { addMonitoring } from "./addMonitoring";
import { removeMonitor } from "./removeMonitor";
import { enableMonitoring } from "./enableMonitoring";
import updateRowStatus from "./updateRowStatus";
import { UploadImage } from "./imageUpload";
import updateAttachmentData from "./updateAttachmentData";
import { clearAllAttachment } from "./clearAllAttachment";
import { clearFileArray } from "./imageUpload/UploadImage";
import { getBoardDetailsAction } from "./fetch-board-details";
import { createCustomFilter } from "./create-custom-filter";
import { removeFilter } from "./remove-filter";
import { editFilter } from "./edit-filter-handler";
import { toggleMenu } from "./toggleMenu";
import removeChildBoardImage from "./removeChildBoardImage";
import { addReasonRowUpdate } from "./add-reason-row-update";
import { dispatchAttachment } from "./dispatchAttachment";
import { clearBoardData } from "./clearBoardData";
import { TodoHandler } from "./todo";
import { isFilterReset } from "./isFilterReset";
import { relateViceVersa } from "./relateViceVersa";
import { userApiCall } from "./User/userApiCall";

const action = {
  fetAllBoards,
  loginDetails,
  storesingleboard,
  deleteboard,
  createattribute,
  fetchAllcolumns,
  renamesingleboard,
  columnOrdering,
  renameAttribute,
  userApiCall,
  showattribute,
  checkLinkForSideMenu,
  hideColumn,
  bulkUpdate,
  removeAttachmnt,
  fetchattributelistingforboard,
  boardDeactivate,
  showColumns,
  activeBoardHandler,
  columnResize,
  updateSingleRow,
  status,
  stopPopup,
  clearAllAttachment,
  getTattleDetails,
  getBoardStatusDetails,
  assignToUpdate,
  getBoardHistory,
  addNoteBoard,
  getNoteBoard,
  keepAllNameAndKey,
  fetchAllRows,
  BoardMessageDeactivate,
  statusChangeMessage,
  setNewStatus,
  addMonitoring,
  removeMonitor,
  enableMonitoring,
  updateRowStatus,
  UploadImage,
  updateAssignTo,
  updateAttachmentData,
  clearFileArray,
  getBoardDetailsAction,
  createCustomFilter,
  removeFilter,
  editFilter,
  isFilterReset,
  toggleMenu,
  removeChildBoardImage,
  addReasonRowUpdate,
  dispatchAttachment,
  clearBoardData,
  TodoHandler,
  relateViceVersa,
};

export default action;
